export const GET_WEAVETYPE_REQUEST = 'GET_WEAVETYPE_REQUEST';
export const GET_WEAVETYPE_DATA = 'GET_WEAVETYPE_DATA';
export const GET_WEAVETYPE_ERROR = 'GET_WEAVETYPE_ERROR';

export const CREATE_WEAVETYPE_REQUEST = 'CREATE_WEAVETYPE_REQUEST';
export const CREATE_WEAVETYPE_DATA = 'CREATE_WEAVETYPE_DATA';
export const CREATE_WEAVETYPE_ERROR = 'CREATE_WEAVETYPE_ERROR';

export const UPDATE_WEAVETYPE_REQUEST = 'UPDATE_WEAVETYPE_REQUEST';
export const UPDATE_WEAVETYPE_DATA = 'UPDATE_WEAVETYPE_DATA';
export const UPDATE_WEAVETYPE_ERROR = 'UPDATE_WEAVETYPE_ERROR';

export const DELETE_WEAVETYPE_REQUEST = 'DELETE_WEAVETYPE_REQUEST';
export const DELETE_WEAVETYPE_DATA = 'DELETE_WEAVETYPE_DATA';
export const DELETE_WEAVETYPE_ERROR = 'DELETE_WEAVETYPE_ERROR';
